<template>
  <div class="xh-esg-index">
    <div class="xh-esg-sj-banner">
      <div class="banner"></div>
    </div>
    <div class="content ">
      <div class="top">
        <span class="icon"><img src="../../assets/white_theme/esg-sj-icon.png" /></span><b
          style="color:var(--font_01);">企业ESG绩效表现</b>
      </div>

      <div class="introduction">
        通过OCR报告图像解析、自然语言处理、知识图谱大数据分析等技术解析上市公司ESG数据，对各公司400+底层数据点进行深度清洗与有效性检验，提升底层数据的完整性、时效性和准确性。目前已形成覆盖A股上市公司2015年至今的上市公司ESG数据库。
      </div>
      <div class="search">
        <div class="searchInput">
          <input type="text" id="searchText" placeholder="请输入企业名称或股票代码" v-model=sizeForm.inputParams @keydown.enter="goSearch()">
          <div class="searchIcon" @click="goSearch()">
            <div class="icon">

            </div>
          </div>
        </div>
      </div>
      <div class="dataTable infoArea">
        <el-table @cell-click="showRowData" v-loading="loading" element-loading-text="数据正在加载中"
          element-loading-spinner="el-icon-loading" :data="tableData" style="width: 100%" :height="maxTableHeight"
          stripe>
          <template slot="empty">
            <div class="noDataTable">暂无数据</div>
          </template>
          <el-table-column prop="index" label="排名" width="100" align="center">
          </el-table-column>
          <el-table-column prop="company_short_name" label="企业名称" width="100">
            <template slot-scope="scope">
              <el-link :underline="false" class="page-table-link">{{
                  scope.row.company_short_name
              }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="stock_code" label="股票代码" width="130">
          </el-table-column>
          <el-table-column prop="record_time" label="时间" width="130">
          </el-table-column>
          <el-table-column prop="secondary_industry" label="所属行业" width="480">
          </el-table-column>
          <el-table-column label="ESG总分" width="160">
            <template slot-scope="scope">
              <el-link :underline="false" style="
                  display: inline;
                  white-space: nowrap;
                  color: #005bac;
                  font-weight: 700;
                ">{{ scope.row.score }}</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-row>
        <el-col :span="24" class="pageArea" v-if="page != null && tableData && tableData.length > 0">
          <el-pagination @current-change="handleCurrentChange" :current-page="page.currentPage"
            :page-sizes="defaultPageSizeList" @size-change="handleSizeChange" :page-size="sizeForm.pageSize"
            layout="total, sizes, prev, slot, next" :total="page.totalCount">
            <el-button style="cursor: not-allowed; margin-left: 5px; margin-right: 5px">{{ page.currentPage + " / " +
                page.totalPage
            }}</el-button>
          </el-pagination>


          <el-input-number @change="clickEnter()" v-model="pageInput" :step="1" :step-strictly="true"
            :controls="inputControl" style="width: 50px; margin-left: 10px" @keyup.native="checknumber($event)"
            :min="1"></el-input-number>
          <el-button @click="clickEnter()" size="mini" type="primary" style="width: 50px;padding: 6px 15px;">GO
          </el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";

import utilKeepComponent from "@/mixins/utilKeepComponent";
export default {
  mixins: [utilKeepComponent],
  willKeepAliveComponents: ['details'],
  data() {
    return {
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
        },
      ],
      tableHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      loading: false,
      page: {
        currentPage: 1,
        totalPage: 1,
        totalCount: 0
      },
      defaultPageSizeList: [10, 20, 30, 50, 100],
      pageInput: 1,
      sizeForm: {
        keyWord: "",
        infoSource: "",
        title: "",
        type: "0",
        pageNo: 1,
        pageSize: 10,
        beginDate: "",
        endDate: "",
        inputParams: ""
      },
      inputControl: false,
    };
  },
  mounted() {
    var _this = this;
    _this.LocalGetTableData();
  },
  methods: {
    ...mapActions("dataInfo/index", {
      getTableData: "GET_TABLE_DATA",
    }),
    goSearch() {
      var _this = this;
      this.loading = true;
      let params = {
        pageNo: 1,
        pageSize: this.sizeForm.pageSize,
        inputParams: this.sizeForm.inputParams
      };
      this.getTableData(params).then((res) => {
        _this.loading = false;
        _this.showNoData = true;
        _this.tableData = res.data;
        let pages = res.page;
        _this.page = {
          currentPage: pages.currentPage,
          totalPage: pages.totalPage,
          totalCount: pages.totalCount
        };
      });
    },
    async showRowData(row, column, event) {
      // this.setSubscribeInfo(row, userId);
      this.$router.push({
        name: "details",
        query: {
          record_time: row.record_time,
          stock_code: row.stock_code,
          company_short_name: row.company_short_name,
          secondary_industry: row.secondary_industry,
          score: row.score,
          diff: row.diff,
          index: row.index,
        },
      });
    },
    checknumber(e) {
      var keynum = window.event ? e.keyCode : e.which; //获取键盘码
      if (keynum == 189 || keynum == 190 || keynum == 109) {
        e.target.value = "";
      }
    },
    handleCurrentChange(val) {
      console.debug(`当前页: ${val}`);
      this.sizeForm.pageNo = val;
      this.LocalGetTableData();
    },
    handleSizeChange(val) {
      console.debug(`每页 ${val} 条`);
      this.sizeForm.pageSize = val;
      this.sizeForm.pageNo = 1
      this.LocalGetTableData();
    },
    clickEnter() {
      // if (this.pageInput)
      console.debug(this.pageInput);
      if (this.pageInput == this.page.currentPage) {
        return;
      }
      if (this.pageInput > this.page.totalPage) {
        this.pageInput = this.page.totalPage;
      }
      this.loading = true;
      this.sizeForm.pageNo = this.pageInput;
      this.LocalGetTableData();
    },
    LocalGetTableData() {
      var _this = this;
      this.loading = true;
      let params = {
        pageNo: this.sizeForm.pageNo,
        pageSize: this.sizeForm.pageSize,
        inputParams: this.sizeForm.inputParams
      };
      this.getTableData(params).then((res) => {
        _this.loading = false;
        _this.showNoData = true;
        _this.tableData = res.data;
        let pages = res.page;
        _this.page = {
          currentPage: pages.currentPage,
          totalPage: pages.totalPage,
          totalCount: pages.totalCount

        };

      });
    },
  },
  computed: {
    maxTableHeight() {
      return this.tableHeight - 190;
    },
  },
};
</script>
<style lang="scss" scoped>
.top {
  margin-top: 25px;
}

.dataTable {
  margin-top: 14px;
  height: 100%;
  width: 100%;

  .noDataTable {
    font-size: 16px;
    font-weight: 500;
  }
}

/deep/.el-input-number.is-without-controls .el-input__inner {
  padding-left: 10px;
  padding-right: 10px;
}
.search {
  margin-top: 14px;
  height: 30px;
  width: 100%;
}

.content {
  width: 1100px;
  margin: 0 auto;
}

.icon {
  margin-right: 13px;
}

.xh-esg-index {
  margin: 0;
  padding: 0;
}

.banner {
  height: 220px;
  background: url("../../assets/white_theme/esg-sj-banner.png") no-repeat;
  background-position: center;
  background-size: cover;
}

.introduction {
  margin-top: 20px;
  margin-bottom: 45px;
  font-size: 14px;
  color: var(--font_01);
}

body {
  margin: 0;
}

.page-table-link {
  display: inline;
  white-space: nowrap;
  color: #005bac;
  font-weight: 700;
}

/deep/ .el-table tr {
  background: var(--xhcj-sj-tr_01);
}

/deep/ .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
  background: var(--xhcj-sj-striped_01);
}

/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
  background: var(--xhcj-sj-tablehover);
}

.top {
  b {
    font-size: 16px;
  }
}

.searchInput {
  border: 1px solid var(--xhcj-sj-search);
  width: 270px;
  height: 28px;
  float: right;
  position: relative;
  border-radius: 2px;
  background: var(--comp_0122);

}

// .searchIcon {
//   width: 15px;
//   height: 18px;
// }

.icon {
  background: url(../../assets/search.png);
  width: 15px;
  height: 18px;
  position: absolute;
  right: 0;
  top: 4px;
  cursor: pointer;
}

#searchText {
  width: 200px;
  height: 25px;
  border: 0;
  background: var(--comp_0122);
  margin-left: 8px;
  border-style: none;
  outline: 0;

  :focus-visible {
    outline: 0;
  }

  color: var(--font_01);
}

input::-webkit-input-placeholder {
  position: relative;
  left: 5px;
}
</style>
